import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import useChangePassword from "../hooks/use-change-password";
import { Button } from "@/components/ui/button";

function ChangePassword() {
	const { form, onSubmit } = useChangePassword();

	return (
		<Form {...form}>
			<form
				onSubmit={form.handleSubmit(onSubmit)}
				className="flex flex-col gap-12"
			>
				<div className="flex flex-col gap-6">
					<p className="web-heading-h4">Change Password</p>

					<div className="flex flex-row md:gap-22">
						<div className="flex w-full flex-col gap-6">
							<FormField
								control={form.control}
								name="password"
								render={({ field }) => (
									<FormItem>
										<FormLabel>Password</FormLabel>
										<FormControl>
											<Input
												{...field}
												required
												placeholder="Password"
												type="password"
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
							<FormField
								control={form.control}
								name="newPassword"
								render={({ field }) => (
									<FormItem>
										<FormLabel>New Password</FormLabel>
										<FormControl>
											<Input
												{...field}
												required
												type="password"
												placeholder="New Password"
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
							<FormField
								control={form.control}
								name="confirmPassword"
								render={({ field }) => (
									<FormItem>
										<FormLabel>Confirm Password</FormLabel>
										<FormControl>
											<Input
												{...field}
												required
												type="password"
												placeholder="Confirm Password"
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>
						<div className="md:w-[150px]"></div>
					</div>
				</div>

				<Button type="submit" className="md:w-60">
					Save Changes
				</Button>
			</form>
		</Form>
	);
}

export default ChangePassword;
